import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from './auth';

export const guestGuard: CanActivateFn = (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  if (auth.authenticated) {
    // Logged in: redirect to home/dashboard
    return router.parseUrl('/');
  }

  // Not logged in: allow access to login or guest pages
  return true;
};